import { onMount, onDestroy, onView } from '@/modules/_'

export default function (element, dataset) {
  console.log('Bar graph module initializing...')

  const animateBars = () => {
    const bars = gsap.utils.toArray('.c-bar-row_track', element)
    const bg = element
    const labels = gsap.utils.toArray('.c-bar-row_label', element)
    const values = gsap.utils.toArray('.c-bar-row_value', element)

    console.log(bars)

    if (bars.length === 0) return

    const tl = gsap.timeline()

    // Animation du background avec delay: 1
    if (bg) {
      tl.from(bg, {
        backgroundColor: '#FFF',
        duration: 0.5,
        ease: 'none',
        delay: 1, // ← delay: 1 pour init ET slideChange
      })
    }

    // Animation des barres
    tl.fromTo(
      bars,
      {
        scaleX: 0,
        transformOrigin: '0% 50%',
      },
      {
        scaleX: 1,
        duration: 1,
        ease: 'power2.out',
        stagger: 0.05,
        onStart: () => {
          bars.forEach((bar) => {
            const value = bar.querySelector('.c-bar-row_value')
            const h4 = value.querySelector('h4, h3, h2, .h4')
            const targetValue = parseFloat(h4.textContent)
            const counter = { value: 0 }

            gsap.to(counter, {
              value: targetValue,
              duration: 2,
              ease: 'power2.out',
              onUpdate: function () {
                h4.textContent = Math.round(counter.value) + '%'
              },
            })
          })
        },
      },
      '0'
    )

    if (labels.length > 0) {
      tl.from(
        labels,
        {
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out',
          stagger: 0.05,
        },
        '<0.5'
      )
    }

    // Animation des values (fade in)
    if (values.length > 0) {
      tl.from(
        values,
        {
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out',
          stagger: 0.05,
        },
        '<'
      )
    }
  }

  onView(element, {
    autoStart: true,
    callback: ({ isIn }) => {
      // console.log("inView", isIn);

      if (isIn) {
        animateBars()
      }
    },
  })
}
